import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signup-sign_up_modal_sign_in_redirect-click';
/**
 * Should be fired when user clicks &quot;sign in&quot; tertiary button in the web sign-up modal and gets redirected to the sign-in modal.
 */
export function trackSignupSignUpModalSignInRedirectClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
